import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { Set } from 'immutable';
import { connect } from 'react-redux';

import { Header } from '../header';
import Spinner from '../Spinner/Spinner';
import { UserRecord } from '../../records/user';
import FirebaseContext from '../Firebase/context';
import AuthScreen from '../../screens/Auth';
import { setUser, setCollection, setShips } from '../../store/actions';
import { CollectionRecord } from '../../records/collection';
import { getDocs } from '../../utils';
import GuestCollectionPreview from '../../screens/GuestCollectionPreview';
import Azurdex from '../../screens/Azurdex';
import Changelog from '../../screens/changelog';
import Events from '../../screens/events';
import { Home2 } from 'screens/Home/index2';
import { RetrofitsScreen } from 'screens/retrofits/index2';

function Layout(props) {
  const history = useHistory();
  const { firebase } = useContext(FirebaseContext);
  // const [user, setUser] = useState(UserRecord());
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  // const [collectionId, setCollectionId] = useState('');

  const { setCollection, setShips, setUser: propsSetUser } = props;

  const createDefaultCollection = useCallback(
    async (collectionRef, userId, username, cid) => {
      if (cid) return;

      const defaultCollectionRecord = CollectionRecord({
        name: `${username} Default`,
        owner: userId,
        ships: Set(),
        retrofits: Set(),
      });

      // log(
      //   `Trying to create default collection for user ${username}. collectionId from state: ${collectionId}. userId: ${userId}`,
      // );

      await collectionRef.add(defaultCollectionRecord.toJS());

      setCollection(defaultCollectionRecord);
      // setCollection(defaultCollectionRecord);
      // setCollectionId(result.id);
    },
    [setCollection],
  );

  // Fetch existing collection.
  const fetchCollection = useCallback(
    async (userId, username) => {
      if (!userId) return;

      const db = firebase.firestore();
      const collectionRef = db.collection('collections');
      const query = collectionRef.where('owner', '==', userId);
      const querySnapshot = await query.get();

      const collectionz = getDocs(querySnapshot).pop() || { id: 0, data: {} };
      const collectionRecord = CollectionRecord({
        id: collectionz.id,
        name: collectionz.data.name,
        owner: collectionz.data.owner,
        ships: Set(collectionz.data.ships),
        retrofits: Set(collectionz.data.retrofits),
        version: collectionz.data.version,
      });

      setCollection(collectionRecord);

      if (collectionz.id === 0) {
        createDefaultCollection(
          collectionRef,
          userId,
          username,
          collectionRecord.id,
        );
      }
    },
    [firebase, setCollection, createDefaultCollection],
  );

  useEffect(() => {
    async function doThings() {
      const handler = (user) => {
        if (user) {
          const userData = {
            id: user.uid,
            name: user.providerData[0].displayName,
            photoURL: user.providerData[0].photoURL,
          };

          localStorage.setItem('userId', user.uid);

          const userRecord = UserRecord(userData);

          propsSetUser(userRecord);
          fetchCollection(userRecord.id, userRecord.name);

          const setAuth = () => {
            setUser(userRecord);
            setIsLoggedIn(true);
            setIsAuthChecked(true);
            setTimeout(() => {
              if (window.location.pathname === '/') {
                history.push('/collection');
              }
            });
          };
          setTimeout(setAuth, 1000);
        } else {
          setIsLoggedIn(false);
          setIsAuthChecked(true);
        }
      };

      firebase.auth().onAuthStateChanged((user) => {
        handler(user);
      });
    }

    doThings();
  }, [firebase, history, fetchCollection, setShips, propsSetUser]);

  // const log = async (msg) => {
  //   const db = firebase.firestore();
  //   const ref = db.collection('logs');

  //   await ref.add({
  //     msg,
  //     user: user.name || 'Unauthorized',
  //     datetime: new Date().toLocaleString(),
  //   });
  // };

  if (!isLoggedIn && isAuthChecked) return <AuthScreen />;

  return (
    <div>
      {!isAuthChecked && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            backgroundColor: '#1c1d1f',
            zIndex: 10,
          }}
        >
          <Spinner size="large" />
        </div>
      )}

      <Header />

      <Route path="/collection" exact component={Home2} />
      <Route path="/user/:id" exact component={GuestCollectionPreview} />
      <Route path="/events" exact component={Events} />

      <Route path="/azurdex" exact component={Azurdex} />
      <Route path="/retrofits" exact component={RetrofitsScreen} />
      <Route path="/changelog" exact component={Changelog} />
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch(setUser(user)),
  setCollection: (collection) => dispatch(setCollection(collection)),
  setShips: (ships) => dispatch(setShips(ships)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
